/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { labelEnumSchema } from "./labelEnumSchema.ts";

export const guestAddressSchema = z.object({
	id: z.uuid(),
	label: labelEnumSchema.optional().describe("* `home` - Дом\n* `work` - Работа\n* `other` - Другое"),
	title: z.string().max(60).optional(),
	city: z.string().max(60),
	flat: z.string().max(10).optional(),
	entrance: z.string().max(10).optional(),
	floor: z.string().max(10).optional(),
	doorphone: z.string().max(10).optional(),
	line1: z.string().max(250).optional(),
	comment: z.string().max(500).optional(),
	latitude: z.number().nullish(),
	longitude: z.number().nullish(),
	is_default: z.boolean().optional(),
	last_used_at: z.iso.datetime().nullable(),
});
